export function langFunction(code, replaces = {}) {
	return window.BX?.Loc?.getMessage('O2K_SALE_ORDER_VUE_' + code, replaces);
}
